import { createContext } from 'react';

import { IDominioSelect } from '../../../modules/types/Dominio';

export interface SelectContextType {
  dominiosSelect: IDominioSelect[];
  carregarDominiosSelect: () => Promise<void>;
  loading: boolean;
}

export const SelectContext = createContext<SelectContextType>({
  dominiosSelect: [],
  carregarDominiosSelect: () => Promise.resolve(),
  loading: false,
});
